import Product from "../model/Product";
import portfolioBeautyIndustry from "./portfolio/portfolioBeautyIndustry";
import portfolioBoldPeople from "./portfolio/portfolioBoldPeople";

import portfolioBooksitout from "./portfolio/portfolioBooksitout";
import portfolioEveryonesGarden from "./portfolio/portfolioEveryonesgarden";
import portfolioPianoman from "./portfolio/portfolioPianoman";
import portfolioSimplyJournal from "./portfolio/portfolioSimplyJournal";
import portfolioSpringfeed from "./portfolio/portfolioSpringfeed";
import portfolioSubstrack from "./portfolio/portfolioSubstrack";
import portfolioPurrfitTracker from './portfolio/portfolioPurrfitTracker'
import portfolioFeaturedDays from "./portfolio/portfolioFeaturedDays";
import portfolioSimplifyGoogleTask from "./portfolio/portfolioSimplifyGoogleTask";
import portfolioRaycastNaverExtension from './portfolio/portfolioRaycastExtensionNaverSearch'
import portfolioLostThings from './portfolio/portfolioLostThings'

const PortfolioData: Product[] = [
	// Visible in IndexRoute
	portfolioBooksitout,
    portfolioLostThings,
	portfolioPurrfitTracker,
	portfolioSubstrack,
	portfolioFeaturedDays,
	portfolioPianoman,

	// Hidden in IndexRoute
    portfolioRaycastNaverExtension,
	portfolioSimplifyGoogleTask,
	portfolioEveryonesGarden,
	portfolioSimplyJournal,
	portfolioBoldPeople,
	portfolioBeautyIndustry,
	portfolioSpringfeed,
]

export default PortfolioData